import Ripple from 'vue-ripple-directive'
import FiatApis from '@/modules/crypto/services/apis/fiat'

const userFiat = new FiatApis()
export default {

  directives: {
    Ripple,
  },
  data() {
    return {
      backgroundImg: '',
      backgroundColor: '#7367f0',
      cardNumber: '#### #### #### ####',
      result: [],
      show: true,

    }
  },
  mounted() {
    userFiat.getFiatInfo().then(res => {
      this.result = res.data.results
      this.show = false
    }).catch(error => {
      console.log(error)
      this.show = false
    })
  },

}
